import { Clock } from 'lucide-react';
import { TEAL_TEXT } from '../constants';
import type { HistoryRowVM } from '../types';

const GRID = '60px 1.6fr 1fr 1fr 110px';

function HeadCell({ label, right }: { label: string; right?: boolean }) {
  return (
    <div
      style={{
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        color: 'var(--muted-foreground)',
        textAlign: right ? 'right' : 'left',
      }}
    >
      {label}
    </div>
  );
}

// History tab run-list (DC §9), with the empty state (DC §11).
export function HistorySection({
  rows,
  onSelectRun,
  isLoadingRun = false,
}: {
  rows: HistoryRowVM[];
  onSelectRun: (runId: number) => void;
  isLoadingRun?: boolean;
}) {
  if (!rows.length) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '48px 0',
          border: '2px dashed var(--border)',
          borderRadius: 12,
          background: 'var(--background)',
        }}
      >
        <Clock style={{ width: 40, height: 40, margin: '0 auto 12px', color: 'var(--muted-foreground)' }} />
        <h3 style={{ fontSize: 20, fontWeight: 600, color: 'var(--foreground)', margin: '0 0 4px' }}>No history yet</h3>
        <p style={{ fontSize: 14, color: 'var(--muted-foreground)', margin: 0 }}>
          Run a perception analysis to see it here.
        </p>
      </div>
    );
  }

  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden', opacity: isLoadingRun ? 0.7 : 1 }}>
      <div style={{ display: 'grid', gridTemplateColumns: GRID, padding: '12px 18px', background: 'var(--muted)', borderBottom: '1px solid var(--border)' }}>
        <HeadCell label="Run" />
        <HeadCell label="Product" />
        <HeadCell label="Models" />
        <HeadCell label="When" />
        <HeadCell label="Score" right />
      </div>
      {rows.map((h) => (
        <div
          key={h.runId}
          onClick={() => !isLoadingRun && onSelectRun(h.runId)}
          style={{
            display: 'grid',
            gridTemplateColumns: GRID,
            padding: '14px 18px',
            borderBottom: '1px solid var(--border)',
            alignItems: 'center',
            cursor: isLoadingRun ? 'wait' : 'pointer',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--muted)')}
          onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
        >
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--muted-foreground)', fontVariantNumeric: 'tabular-nums' }}>
            #{h.run}
          </div>
          <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--foreground)' }}>{h.product}</div>
          <div style={{ fontSize: 13, color: 'var(--muted-foreground)' }}>{h.models}</div>
          <div style={{ fontSize: 13, color: 'var(--muted-foreground)' }}>{h.when}</div>
          <div style={{ textAlign: 'right', fontSize: 15, fontWeight: 700, color: TEAL_TEXT, fontVariantNumeric: 'tabular-nums' }}>
            {h.score}
          </div>
        </div>
      ))}
    </div>
  );
}
